import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-menu-item",
  standalone: true,
  imports: [NgClass],
  templateUrl: "./menu-item.component.html",
  styleUrl: "./menu-item.component.scss",
})
export class MenuItemComponent {
  @Input() icon: string = "";
  @Input() isActive: boolean = false;
  @Input() title: string = "";
  @Input() unsavedContent: boolean = false;
}
